module.exports = __webpack_public_path__ + "static/media/progress-icon-blue.40bc08c1.svg";